import React from 'react';
import store from '../../store/Store';

import actionTypes from '../../actionTypes/actionTypes';
import actions from '../../actions/Actions';

import { Redirect } from 'react-router-dom';

import './editorTestArea.scss';

type editorTestAreaState = {
	article: any;
  	navigation: any;
}

type editorTestAreaProps = {
	article: any;
  	navigation: any;
}

class EditorTestArea extends React.Component<editorTestAreaState, editorTestAreaProps> {

  constructor(props) {
  	super(props)

    console.log(this.props)

  	this.state = {
  		article: props.article,
      navigation: props.navigation
  	}
  }

  componentDidMount() {
    console.log('EditorTestArea Did Mount')

  	store.subscribe(() => {
  		this.setState({
  			article: store.getState().article,
        	navigation: store.getState().navigation
  		})
  	})

  	const table = document.getElementById('table')
  	const columns = table.querySelectorAll('th')
  	const rows = table.querySelectorAll('tr')

  	console.log(table)
  	console.log(columns)
  	console.log(rows)

  	columns.forEach((column, index, array) => {
  		console.log(index + ' ' + column)

  		const colResizer = document.createElement('div')
  		colResizer.classList.add('colResizer')
  		colResizer.style.height = '100vh'
  		colResizer.style.position = 'absolute'
  		colResizer.style.top = '0'
  		colResizer.style.right = '0'
  		colResizer.style.width = '5px'
  		colResizer.style.cursor = 'col-resize'
  		colResizer.style.userSelect = 'none'
  		colResizer.style.zIndex = '1'

  		column.appendChild(colResizer)

  		this.createResizeableColumn(column, colResizer)
  	})

  	rows.forEach((row, index, array) => {
  		console.log(index + ' ' + row)

  		const rowResizer = document.createElement('div')
  		rowResizer.classList.add('rowResizer')
  		rowResizer.style.height = '5px'
  		rowResizer.style.position = 'absolute'
  		rowResizer.style.bottom = '0'
  		rowResizer.style.left = '0'
  		rowResizer.style.width = '100vw'
  		rowResizer.style.cursor = 'row-resize'
  		rowResizer.style.userSelect = 'none'

  		row.appendChild(rowResizer)

  		this.createResizeableRow(row, rowResizer)
  	})
  }

  componentWillUnmount() {
    console.log('EditorTestArea Will Unmount')

    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation
      })
    })
  }

  createResizeableColumn = (column, colResizer) => {
  	let width = 0
  	let mouseDown = 0
  	let mouseMoved = 0

  	const colMouseDownHandler = (event) => {
		mouseDown = event.clientX

		const styles = window.getComputedStyle(column)
		width = parseInt(styles.width, 10)

		document.addEventListener('mousemove', columnMouseMoveHandler, false)
		document.addEventListener('mouseup', columnMouseUpHandler, false)

		colResizer.classList.add('resizing')
	}

	const columnMouseMoveHandler = (event) => {
		column.style.width = (width + (event.clientX - mouseDown)) + 'px'
	}

	const columnMouseUpHandler = (event) => {	  	
		document.removeEventListener('mousemove', columnMouseMoveHandler, false)
		document.removeEventListener('mouseup', columnMouseUpHandler, false)

		colResizer.classList.remove('resizing')
	}

  	colResizer.addEventListener('mousedown', colMouseDownHandler, false)
  }

  createResizeableRow = (row, rowResizer) => {
  	let height = 0
  	let mouseDown = 0
  	let mouseMoved = 0

  	const rowMouseDownHandler = (event) => {
		mouseDown = event.clientY

		const styles = window.getComputedStyle(row)
		height = parseInt(styles.height, 10)

		document.addEventListener('mousemove', rowMouseMoveHandler, false)
		document.addEventListener('mouseup', rowMouseUpHandler, false)

		rowResizer.classList.add('resizing')
	}

	const rowMouseMoveHandler = (event) => {
		row.style.height = (height + (event.clientY - mouseDown)) + 'px'
	}

	const rowMouseUpHandler = (event) => {
		document.removeEventListener('mousemove', rowMouseMoveHandler, false)
		document.removeEventListener('mouseup', rowMouseUpHandler, false)

		rowResizer.classList.remove('resizing')
	}

  	rowResizer.addEventListener('mousedown', rowMouseDownHandler, false)
  }

	render() {
		const {
			article,
      		navigation
		} = this.state

    console.log(article)
    console.log(navigation)

		return (
			<div
				className="EditorTestArea"
		        style={{
					width: '100vw',
					height: '100vh'
		        }}
			>
        		<table
        			id={ 'table' }
        			style={{
        				width: 'calc(100vw + 120px)',
		          		height: '100vh',
		          		borderSpacing: 40,
        				margin: '0 0 0 -40px',
        				padding: 0,
        				backgroundColor: 'rgba(96, 96, 96, 255)'
        			}}
        		>
        			<thead
        				style={{
        					position: 'relative',
	        				backgroundColor: 'rgba(127, 127, 127, 255)'
	        			}}
        			>
        				<tr
        					style={{
        						position: 'relative',
		        				backgroundColor: 'rgba(224, 224, 224, 255)'
		        			}}
        				>

        					{
        						['1', '2', '3'].map((item, index, array) => {
									return (
										<th
			        						style={{
			        							position: 'relative',
						        				backgroundColor: 'rgba(196, 196, 196, 255)'
						        			}}	
			        					>
			        						{ index === 1 ? null : index }
			        					</th>
			        				)
        						})
        					}

        				</tr>
        			</thead>

        			<tbody
        				style={{
        					position: 'relative',
	        				backgroundColor: 'rgba(127, 127, 127, 255)'
	        			}}
        			>
        				<tr
        					style={{
        						position: 'relative',
		        				backgroundColor: 'rgba(224, 224, 224, 255)'
		        			}}
        				>

        					{
        						['1', '2', '3'].map((item, index, array) => {
									return (
										<td
			        						style={{
			        							position: 'relative',
						        				backgroundColor: 'rgba(196, 196, 196, 255)'
						        			}}
			        					>
			        						{ index }
			        					</td>
			        				)
        						})
        					}
        					
        				</tr>
        			</tbody>
        		</table>
			</div>
		);
	}
}

export default EditorTestArea;